import request from "../utils/request";

const schemeApi = {
    SchemeList: 'filtrate/person',
    PatientList: 'confirmed/patient',
    Scheme: "common/search/patient"
}
export function getPatientList(parameter) {
    return request({
        url: schemeApi.SchemeList,
        method: "post",
        data: parameter,

    })
}
export function getConfirmedList(parameter) {
    return request({
        url: schemeApi.PatientList,
        method: "post",
        data: parameter,

    })
}

export function querySearch({ keywords, type }) {
    return request({
        url: schemeApi.Scheme,
        method: "get",
        params: {
            keywords,
            type
        },

    })
}